import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Light, Dark } from '../styles/Themes'
import { styled, ThemeProvider } from 'styled-components'

import Sidebar from '../components/home/Sidebar'
import Copyright from '../components/home/Copyright'
import PageInfo from '../components/home/PageInfo'
import { ToastContainer } from "react-toastify"

export const ThemeContext = React.createContext(null)

function Home() {
  const location = useLocation()

  const [theme, setTheme] = useState("light")
  const [sideBarOpen, setSideBarOpen] = useState(false)
  const themeStyle = theme === "light" ? Light : Dark

  // Determinar la página actual basada en la ruta
  const getPageName = () => {
    const path = location.pathname
    if (path.includes('/devices/')) return null
    if (path.includes('/devices')) return 'Dispositivos'
    if (path.includes('/dashboard')) return 'Dashboard'
    if (path.includes('/map')) return 'Mapa'
    return 'Dashboard' // default
  }

  return (
    <ThemeContext.Provider value={{ setTheme, theme }}>
      <ThemeProvider theme={themeStyle}>
        <ToastContainer
          position="top-center"
          hideProgressBar={false}
          newestOnTop={false}
          pauseOnHover={false}
          pauseOnFocusLoss={false}
          closeOnClick={false}
          rtl={false}
          theme="light"
        />
        <Container className={sideBarOpen ? "sidebarState active" : "sidebarState"}>
          
          <Sidebar
            sideBarOpen={sideBarOpen}
            setSideBarOpen={setSideBarOpen}
            theme={theme}
            setTheme={setTheme}
          />
          <div className='mainRender'>
            
            {getPageName() !== null &&
              <div className='pageinfo'>
                <PageInfo homeRender={getPageName()} />
              </div>
            }
            
            <Outlet context={{ theme }} />
            
            <div className='copyright'>
              <Copyright />
            </div>
          </div>
        </Container>
      </ThemeProvider>
    </ThemeContext.Provider>
  )
}

const Container = styled.div`
    display: grid;
    height: 100vh;
    max-width: 100vw;
    overflow: hidden;
    grid-template-columns: 90px auto;
    background: ${({theme})=> theme.bgtotal};
    color:${({theme})=>theme.text};
    transition:all 0.3s ;
    &.active{
        grid-template-columns: 300px auto;
    }

    .mainRender{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: 1% 5% 0 5%;
        width: 90%;
        min-height: 600px;
        height: auto;
        overflow-y: auto;
        overflow-x: hidden;
        gap: 10px;

        .pageinfo{
            display:flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
        }
        .copyright{
        }
    }
`;

export default Home